import React, {Component} from 'react';
import ReceiveOverView from "./ReceiveOverView";
import LineHauls from "../linehaul/LineHauls";
import ReceiveFilter from "./ReceiveFilter";
import ReceiveFilterContextProvider from "./context/ReceiveFilterContext";
import ReceiveOverViewContextProvider from "./context/ReceiveOverViewContext";
import LineHaulListContextProvider from "../linehaul/context/LineHaulListContext";
import ReceiveGroupByContextProvider from "./context/ReceiveGroupByContext";
import ReceiveGroupBy from "./ReceiveGroupBy";
import CapabilityContextProvider from "../global/context/ConfigContext";

class Receive extends Component {

    render() {
        return (
            <ReceiveFilterContextProvider>
                <CapabilityContextProvider>
                    <ReceiveFilter/>
                    <ReceiveOverViewContextProvider>
                        <ReceiveOverView/>
                    </ReceiveOverViewContextProvider>
                    <ReceiveGroupByContextProvider>
                        <ReceiveGroupBy/>
                        <LineHaulListContextProvider>
                            <LineHauls history={this.props.history}/>
                        </LineHaulListContextProvider>
                    </ReceiveGroupByContextProvider>
                </CapabilityContextProvider>
            </ReceiveFilterContextProvider>

        )
    }
}

export default Receive;


// WEBPACK FOOTER //
// ./src/components/receive/Receive.js